// A CONTA DOS ENDEREÇOS LIMPOS (06/10/2026).
//
// O endereço limpo (`/processos/27`) não diz de que conta é. Vale a conta
// PRINCIPAL da pessoa (`user.account_id`), guardada neste navegador para que
// o primeiro carregamento já saiba traduzir. Endereço de outra conta continua
// no formato completo, sem ambiguidade.
//
// `contaAtual` é a conta da tela aberta — quem antes lia a conta do
// `window.location.pathname` (cliente da API, upload, funil) lê daqui.
import { ehEnderecoDoApp } from './traducao';

const CHAVE = 'advup:conta-principal';

let principal = null;
let atual = null;

const ler = () => {
  try {
    return window.localStorage.getItem(CHAVE);
  } catch {
    return null;
  }
};

export const contaPrincipal = () => {
  if (principal === null) principal = ler();
  return principal;
};

export const guardarContaPrincipal = conta => {
  if (!conta) return;
  principal = String(conta);
  try {
    window.localStorage.setItem(CHAVE, principal);
  } catch {
    // sem armazenamento: vale só nesta aba
  }
};

export const contaAtual = () => atual || contaPrincipal();

export const marcarContaAtual = conta => {
  if (conta && conta !== '0') atual = String(conta);
};

// A conta da tela, para quem não fala com o roteador (cliente da API, upload,
// funil). Endereço antigo: a conta está nele. Endereço limpo do app: a conta
// da tela aberta. Fora do app (login, central de ajuda): nenhuma.
export const contaDaTela = () => {
  if (typeof window === 'undefined') return null;
  const caminho = window.location.pathname;
  const casou = /^\/app\/accounts\/(\d+)/.exec(caminho);
  if (casou) return casou[1];
  return ehEnderecoDoApp(caminho) ? contaAtual() : null;
};

// Só para os testes.
export const esquecerContas = () => {
  principal = null;
  atual = null;
};
